import React, { useCallback, useEffect, useState, useId} from 'react'
import { Modal, Form, Spinner } from 'react-bootstrap'
import { ButtonWithLoadingState } from '../Buttons'
import { t } from 'i18next'
import UniversalTableWrapperTest from '../Table/UniversalTableWrapperTest'
import BootstrapTable from 'react-bootstrap-table-next'
import { useTableState } from '../Table/TableProvider'
import { ErrorAlerts, makeCall } from '../../utils/api/makeCall'
import { APIEndpoints } from '../../utils/api/apiConfig'
import apiClient from '../../utils/api/apiClient'

const WarehousesSelectModal = ({ selectedWarehouses, setSelectedWarehouses, handleSave, handleSaveIsLoading, setShowAddWarehousesModal, singleSelection }) => {
  const [errorStates, setErrorStates] = useState({})
  const [loadingStates, setLoadingStates] = useState({})
  const [warehouses, setWarehouses] = useState([])
  const { tableRef } = useTableState()
  const [allSelected, setAllSelected] = useState(false)

  const columns = [
    {
        dataField: 'checked',
        text: '',
        headerClasses: 'checkBox-header-cell',
        classes: 'checkBox-cell',
        sort: false,
        formatter: (cell, row, rowIndex, extraProps) => {
            let warehouseId = row.id;
            let checked = selectedWarehouses.findIndex(wh => wh.id === warehouseId) >=0
            return <span> <input id={row.id} type="checkbox" checked={checked} onChange={() => { }} /></span>
          }, formatExtraData: {
            selectedWarehouses,
            selectedWarehousesTrigger: selectedWarehouses.length
          }
    },
    {
        dataField: 'location.displayName',
        text: t('reportConfig:location'),
        sort: true,
    }
    ,
    {
        dataField: 'displayName',
        text: t('reportConfig:warehouse'),
        sort: true,
    },

  ]

  const handleClose = () => {
    setShowAddWarehousesModal(false)
  }
    const loadWarehouses = useCallback(async () => {
        makeCall('loadWarehouses', async () => {
            let loadWarehouses = await apiClient.getJson(APIEndpoints.storehouses())
            /*if (loadWarehouses.length) {
                loadWarehouses.sort((a, b) => a.location.displayName > b.location.displayName ? 1 : -1)
            }*/
            setWarehouses(loadWarehouses)
        }, setErrorStates, setLoadingStates)
    
    }, [])
  useEffect(() => {
    loadWarehouses()
  }, [loadWarehouses])
  useEffect(() => {
    setAllSelected(selectedWarehouses.length===warehouses.length)
  }, [setAllSelected, selectedWarehouses, warehouses])

  const handleCheckedBox = (cell, row, rowIndex) => {
    setAllSelected(false)
    let warehouseId = row.id;
    let newSelectedWarehouses = [...selectedWarehouses]
    let existingWarehouseIndex = selectedWarehouses.findIndex(wh => wh.id === warehouseId)
    if (existingWarehouseIndex >= 0) {
        newSelectedWarehouses.splice(existingWarehouseIndex, 1)
        setSelectedWarehouses(newSelectedWarehouses)
    } else {
      if (singleSelection) newSelectedWarehouses = []
        newSelectedWarehouses.push(row)
        setSelectedWarehouses(newSelectedWarehouses)
    } 
  }
  const selectAll = async () => {
    if (!allSelected) {
        setSelectedWarehouses(warehouses)
    }
    else { 
        setSelectedWarehouses([])
    }
    setAllSelected(prev => !prev)
  }
  const checkboxId = useId()
  return (
    <Modal size="lg" centered show={true} onHide={handleClose} scrollable>
      <Modal.Header closeButton className="pb-0">
        <Modal.Title>
          <div>
            <p className="m-0 pt-2">{t('reportConfig:warehousesSelect')}</p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <UniversalTableWrapperTest tableIsLoading={loadingStates.loadWarehouses}>
          <BootstrapTable
            ref={tableRef}
            noDataIndication={() => { <div className="no-data-placeholder">No Data</div> }}
            bootstrap4
            keyField="id"
            hover
            data={warehouses}
            columns={columns}
            bordered={false}
            rowEvents={{ onClick: handleCheckedBox }}
          />
        </UniversalTableWrapperTest>
        <ErrorAlerts errorStates={errorStates} />
      </Modal.Body>
      <Modal.Footer>
        {loadingStates.loadWarehouses
                ? <div className="flex-grow-1 bd-highlight"><Spinner size="sm" className="mt-2" animation='border' variant='primary' /></div>
                : (!singleSelection && warehouses.length) ? <div className="flex-grow-1 bd-highlight"><Form.Check
                className="mt-2"
                label={t('order:selectAll')}
                id={checkboxId}
                checked={allSelected}
                onChange={selectAll}
                /></div>
                : null}
        <ButtonWithLoadingState
          variant='primary'
          buttonText={`${t('saveButton')} ${selectedWarehouses.length ? `(${selectedWarehouses.length})` : ''}`}
          isLoading={handleSaveIsLoading}
          onClick={handleSave}
        />
      </Modal.Footer>
    </Modal >
  )
}

export default WarehousesSelectModal